module.exports = __webpack_public_path__ + "img/icon-video.e637a187.svg";